/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'common.pages.creditInformation.Header',
        defaultMessage: 'Pre-Contract Credit Information'
    },
    SubHeader: {
        id: 'common.pages.creditInformation.SubHeader',
        defaultMessage: 'A detailed Credit Agreement will be sent to you when you buy your policy'
    },
    HeaderContactDetails: {
        id: 'common.pages.creditInformation.HeaderContactDetails',
        defaultMessage: '1. Contact details'
    },
    HeaderKeyFeatures: {
        id: 'common.pages.creditInformation.HeaderKeyFeatures',
        defaultMessage: '2. Key features of the credit product'
    },
    HeaderCostOfTheCredit: {
        id: 'common.pages.creditInformation.HeaderCostOfTheCredit',
        defaultMessage: '3. Costs of the credit'
    },
    HeaderLegalAspects: {
        id: 'common.pages.creditInformation.HeaderLegalAspects',
        defaultMessage: '4. Other important legal aspects'
    },
    HeaderAdditionalInformation: {
        id: 'common.pages.creditInformation.HeaderAdditionalInformation',
        defaultMessage: '5. Additional information in the case of distance marketing of financial services'
    },
    ContactDetailsHeader1: {
        id: 'common.pages.creditInformation.ContactDetailsHeader1',
        defaultMessage: 'Creditor'
    },
    ContactDetailsValue1: {
        id: 'common.pages.creditInformation.ContactDetailsValue1',
        defaultMessage: 'Saga Services Limited'
    },
    ContactDetailsHeader2: {
        id: 'common.pages.creditInformation.ContactDetailsHeader2',
        defaultMessage: 'Address'
    },
    ContactDetailsValue2: {
        id: 'common.pages.creditInformation.ContactDetailsValue2',
        defaultMessage: '3 Pancras Square, London N1C 4AG.'
    },
    ContactDetailsHeader3: {
        id: 'common.pages.creditInformation.ContactDetailsHeader3',
        defaultMessage: 'Telephone'
    },
    ContactDetailsHeader4: {
        id: 'common.pages.creditInformation.ContactDetailsHeader4',
        defaultMessage: 'Email address'
    },
    KeyFeaturesHeader1: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader1',
        defaultMessage: 'The type of credit'
    },
    KeyFeaturesValue1: {
        id: 'common.pages.creditInformation.KeyFeaturesValue1',
        defaultMessage: 'Fixed Sum Loan'
    },
    KeyFeaturesHeader2: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader2',
        defaultMessage: 'The total amount of credit. This means the total amount of credit to be provided under the proposed credit agreement or the credit limit.'
    },
    KeyFeaturesValue2: {
        id: 'common.pages.creditInformation.KeyFeaturesValue2',
        defaultMessage: '(The amount will be confirmed when you buy)'
    },
    KeyFeaturesHeader3: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader3',
        defaultMessage: 'How and when the credit would be provided.'
    },
    KeyFeaturesValue3: {
        id: 'common.pages.creditInformation.KeyFeaturesValue3',
        defaultMessage: 'The credit will be provided by Saga Services Limited on the date the agreement is made in order to fund the provision of an annual insurance policy by Saga Services Limited starting on the day your policy commences.'
    },
    KeyFeaturesHeader4: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader4',
        defaultMessage: 'The duration of the credit agreement.'
    },
    KeyFeaturesValue4: {
        id: 'common.pages.creditInformation.KeyFeaturesValue4',
        defaultMessage: '12 months'
    },
    KeyFeaturesHeader5: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader5',
        defaultMessage: 'Repayments.'
    },
    KeyFeaturesValue5: {
        id: 'common.pages.creditInformation.KeyFeaturesValue5',
        defaultMessage: '(To be confirmed when you buy)'
    },
    KeyFeaturesHeader6: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader6',
        defaultMessage: 'The total amount you will have to pay. This means the amount you have borrowed plus interest and other costs.'
    },
    KeyFeaturesValue6a: {
        id: 'common.pages.creditInformation.KeyFeaturesValue6a',
        defaultMessage: 'Total amount of credit'
    },
    KeyFeaturesValue6b: {
        id: 'common.pages.creditInformation.KeyFeaturesValue6b',
        defaultMessage: 'Total charge for credit (interest)'
    },
    KeyFeaturesValue6c: {
        id: 'common.pages.creditInformation.KeyFeaturesValue6c',
        defaultMessage: 'Amount payable by instalment'
    },
    KeyFeaturesValue6d: {
        id: 'common.pages.creditInformation.KeyFeaturesValue6d',
        defaultMessage: 'Deposit (paid)'
    },
    KeyFeaturesHeader7: {
        id: 'common.pages.creditInformation.KeyFeaturesHeader7',
        defaultMessage: 'The proposed credit will be granted in the form of deferred payment for goods or services.'
    },
    KeyFeaturesValue7a: {
        id: 'common.pages.creditInformation.KeyFeaturesValue7a',
        defaultMessage: 'Total cash price'
    },
    KeyFeaturesValue7b: {
        id: 'common.pages.creditInformation.KeyFeaturesValue7b',
        defaultMessage: 'Saga {productName} Insurance policy.'
    },
    CostsHeader1: {
        id: 'common.pages.creditInformation.CostsHeader1',
        defaultMessage: 'The rates of interest which apply to the credit agreement.'
    },
    CostsValue1: {
        id: 'common.pages.creditInformation.CostsValue1',
        defaultMessage: 'The interest rate that applies to the Credit Agreement is {rate}% per annum.'
    },
    CostsHeader2: {
        id: 'common.pages.creditInformation.CostsHeader2',
        defaultMessage: 'Annual Percentage Rate of Charge (APR). This is the total cost expressed as an annual percentage of the total amount of credit. The APR is there to help you compare different offers.'
    },
    CostsValue2: {
        id: 'common.pages.creditInformation.CostsValue2',
        defaultMessage: 'The APR that applies to the Credit Agreement is {apr}%'
    },
    CostsValue3: {
        id: 'common.pages.creditInformation.CostsValue3',
        defaultMessage: ' Please note that these are our normal rates, but because Saga caps the interest we charge at £150 per policy year, your actual interest rate is lower than the figure shown'
    },
    CostsHeader3: {
        id: 'common.pages.creditInformation.CostsHeader3',
        defaultMessage: 'Related costs'
    },
    CostsHeader4: {
        id: 'common.pages.creditInformation.CostsHeader4',
        defaultMessage: 'Costs in the case of late payments.'
    },
    CostsValue4: {
        id: 'common.pages.creditInformation.CostsValue4',
        defaultMessage: 'The rate of interest on late or missed payments is as set out above.'
    },
    CostsHeader5: {
        id: 'common.pages.creditInformation.CostsHeader5',
        defaultMessage: 'Consequences of missing payments.'
    },
    CostsValue5: {
        id: 'common.pages.creditInformation.CostsValue5',
        defaultMessage: 'Missing payments under the Credit Agreement may lead to your Product being cancelled, and may make it more difficult to obtain credit in the future.'
    },
    OtherLegalAspectsHeader1: {
        id: 'common.pages.creditInformation.OtherLegalAspectsHeader1',
        defaultMessage: 'Right of withdrawal.'
    },
    OtherLegalAspectsValue1: {
        id: 'common.pages.creditInformation.OtherLegalAspectsValue1',
        defaultMessage: 'You have the right to withdraw from the Credit Agreement (without giving us any reason) within a period of 14 calendar days starting on the date of the covering letter that you received with the Credit Agreement and ending 14 days after that day.'
    },
    OtherLegalAspectsHeader2: {
        id: 'common.pages.creditInformation.OtherLegalAspectsHeader2',
        defaultMessage: 'Early repayment.'
    },
    OtherLegalAspectsValue2: {
        id: 'common.pages.creditInformation.OtherLegalAspectsValue2',
        defaultMessage: 'You have the right to settle the Credit Agreement early at any time in full or partially.'
    },
    OtherLegalAspectsHeader3: {
        id: 'common.pages.creditInformation.OtherLegalAspectsHeader3',
        defaultMessage: 'Consultation with a credit reference agency.'
    },
    OtherLegalAspectsValue3: {
        id: 'common.pages.creditInformation.OtherLegalAspectsValue3',
        defaultMessage: 'If Saga Services Limited decides not to enter into a Credit Agreement with you on the basis of information obtained from a credit reference agency, Saga Services Limited must inform you that this decision has been reached and provide you with details of the relevant agency.'
    },
    OtherLegalAspectsHeader4: {
        id: 'common.pages.creditInformation.OtherLegalAspectsHeader4',
        defaultMessage: 'Right to a draft credit agreement.'
    },
    OtherLegalAspectsValue4: {
        id: 'common.pages.creditInformation.OtherLegalAspectsValue4',
        defaultMessage: 'You have the right, upon request, to obtain a copy of Saga Services Limited\'s draft Credit Agreement free of charge, unless Saga Services Limited is unwilling at the time of the request to proceed to the conclusion of the Credit Agreement.'
    },
    AdditionalInformationHeader1: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader1',
        defaultMessage: '(a) concerning the creditor.'
    },
    AdditionalInformationHeader2: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader2',
        defaultMessage: 'Registration number.'
    },
    AdditionalInformationValue2: {
        id: 'common.pages.creditInformation.AdditionalInformationValue2',
        defaultMessage: 'Financial Services Register Number: {number}'
    },
    AdditionalInformationHeader3: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader3',
        defaultMessage: 'The supervisory authority.'
    },
    AdditionalInformationValue3: {
        id: 'common.pages.creditInformation.AdditionalInformationValue3',
        defaultMessage: 'Financial Conduct Authority.'
    },
    AdditionalInformationHeader4: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader4',
        defaultMessage: '(b) concerning the credit agreement.'
    },
    AdditionalInformationHeader5: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader5',
        defaultMessage: 'The law taken by the creditor as a basis for the establishment of relations with you before conclusion of the credit agreement.'
    },
    AdditionalInformationValue5: {
        id: 'common.pages.creditInformation.AdditionalInformationValue5',
        defaultMessage: 'English law.'
    },
    AdditionalInformationHeader6: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader6',
        defaultMessage: 'The law applicable to the credit agreement and/or the competent court.'
    },
    AdditionalInformationValue6: {
        id: 'common.pages.creditInformation.AdditionalInformationValue6',
        defaultMessage: 'Credit Agreement is subject to English law and the English courts shall have jurisdiction with respect to any dispute arising from or in relation to it.'
    },
    AdditionalInformationHeader7: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader7',
        defaultMessage: 'Language to be used in connection with the credit agreement.'
    },
    AdditionalInformationValue7: {
        id: 'common.pages.creditInformation.AdditionalInformationValue7',
        defaultMessage: 'English.'
    },
    AdditionalInformationHeader8: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader8',
        defaultMessage: '(c) concerning redress.'
    },
    AdditionalInformationHeader9: {
        id: 'common.pages.creditInformation.AdditionalInformationHeader9',
        defaultMessage: 'Access to out-of-court complaint and redress mechanism.'
    },
    AdditionalInformationValue9: {
        id: 'common.pages.creditInformation.AdditionalInformationValue9',
        defaultMessage: 'If you are unable to resolve a complaint with us and have received a final response from us confirming this, you may refer it to the Financial Ombudsman Service, Exchange Tower, Harbour Exchange Square, London, E14 9SR.'
    },
});
